import { toast } from 'react-toastify';

import { SUBMISSION_FAILED } from '../constants/generals';
import { IHistory } from '../interfaces';
import { UserModel } from '../model/UserModel';
import { delDev, getDev, postDev, putDev, updatePasswordDev } from '../utils/HTTPDev';
import { logoutUser } from './loginService';
import { isArray } from 'util';

export async function getUser(userId: number) {
    try {
        const response = await getDev(`/user/${userId}`);
        response.data.data.id =  response.data.data.UniqueId;
        new UserModel(response.data.data).$save();
        return response;
    } catch (error) {
        throw error;
    }
}

export async function getAllUsers() {
    try {
        const response = await getDev(`/user`);
        for (const key in response.data.data) {
            const userInstance = response.data.data;
            userInstance[key].id = key;
            new UserModel(userInstance[key]).$save();
        }
    } catch (error) {
        throw error;
    }
}

export async function createNewUser(userData, history) {

    const userInstance = {
        UserId: parseInt(userData.UserId),
        Password: userData.Password,
        First_Name: userData.First_Name,
        Middle_Name: userData.Middle_Name || null,
        Last_Name: userData.Last_Name,
        Email: userData.Email,
        Access_Level: userData.Access_Level,
        Plants: !isArray(userData.Plants) ?  userData.Plants.split(',') : [],
        Job_Title: userData.Job_Title,
        Job_Desc: userData.Job_Desc
    };
    try {
        const response = await postDev('/user', userInstance);
        history.push('/user/list');
        toast.success('User Created Successfully.', {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast',
            onClose: history.push('/user/list'),
            autoClose: 1000
        });
        await getAllUsers();
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

export async function deleteUser(userId: string, history: IHistory) {
    try {
        const response = await delDev(`/user/${userId}`);
        const userInstance = UserModel.get(userId);
        new UserModel(userInstance.props).$delete();
        history.push(`/user/list`);
        await getAllUsers();
        toast.success('User Deleted Successfully.', {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast',
        });
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}
export async function updatePasswordUser(userId: string, history: IHistory) {
    try {
        const response = await updatePasswordDev(`/updateuserpassword/${userId}`);
        history.push(`/user/list`);
        toast.success('User Password Updated to the Default Password Argos2017 Successfully.', {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast',
        });
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error; 
    }
}
function getPlants(plants) {
    if (typeof plants === 'string') {
        if (plants.length === 0) {
            return [];
        }
        return plants.split(',');
    }
    return plants;
}

export async function updateUser(userData, userId, history) {
    const updateData = {
        First_Name: userData.First_Name,
        Middle_Name: userData.Middle_Name || null,
        Last_Name: userData.Last_Name,
        Email: userData.Email,
        Access_Level: userData.Access_Level,
        Plants: getPlants(userData.Plants),
        Job_Title: userData.Job_Title,
        Job_Desc: userData.Job_Desc
    };
    try {
        const response = await putDev(`/user/${userId}`, updateData);
        const userInstance = UserModel.get(userId);
        new UserModel(userInstance).$delete();
        toast.success('User Updated Successfully.', {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast',
            onClose: history.push('/user/list'),
            autoClose: 1000
        });
        await getAllUsers();
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

export async function updatePassword(oldPassword, newPassword, userId, instance, history) {
    try {
        const response = await putDev(`/updatepassword/${userId}`,
            { Old_Password: oldPassword, New_Password: newPassword });
        logoutUser(history);
        toast.success('Password Updated Successfully.', {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast'
        });
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        instance.setState({
            isLoading: false
        });
        throw error;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/userService.ts